import React, { useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Share2, Check } from 'lucide-react';
const SHARE_URL = 'https://openwaterdiver.buceoynavegacion.com';
const SHARE_DATA = {
  title: 'Curso de Buceo Inicial PADI | Buceo y Navegación',
  text: 'Obtené tu certificación internacional PADI y empezá a explorar el mundo submarino.',
  url: SHARE_URL
};
export function FloatingShare() {
  const [toast, setToast] = useState<string | null>(null);
  const showToast = (msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(null), 3000);
  };
  const copyToClipboard = async (text: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }
    } catch {
      // fall through to legacy method
    }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch {
      // ignore — confirmation toast still shows
    }
  };
  const handleShare = async () => {
    const canNativeShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function' && (typeof navigator.canShare !== 'function' || navigator.canShare(SHARE_DATA));
    if (canNativeShare) {
      try {
        await navigator.share(SHARE_DATA);
        return;
      } catch (err) {
        if (err instanceof Error && err.name === 'AbortError') return;
        // fall through to clipboard fallback
      }
    }
    const clipboardText = `${SHARE_DATA.title}\n\n${SHARE_DATA.text}\n\n${SHARE_URL}`;
    await copyToClipboard(clipboardText);
    showToast('Enlace copiado. Compartilo con quien quieras.');
  };
  return <>
      <motion.button type="button" onClick={handleShare} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 22
    }} aria-label="Compartir curso" className="fixed bottom-24 right-6 z-50 flex items-center gap-2.5 bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] rounded-full pl-4 pr-5 py-3 shadow-[0_8px_24px_-4px_rgba(0,184,217,0.55)]" data-id="element-177">
        <Share2 size={22} strokeWidth={2.5} className="shrink-0" data-id="element-178" />
        <span className="hidden sm:inline font-bold text-sm whitespace-nowrap" data-id="element-179">
          Compartir curso
        </span>
      </motion.button>

      {/* Toast */}
      <AnimatePresence data-id="element-180">
        {toast && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.3
      }} role="status" aria-live="polite" className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 rounded-full bg-brand-dark/95 backdrop-blur-sm border border-brand-primary/30 text-white text-sm font-medium px-5 py-3 shadow-[0_12px_40px_-8px_rgba(0,0,0,0.6)] max-w-[90vw]" data-id="element-181">
            <span className="w-5 h-5 rounded-full bg-brand-primary/20 flex items-center justify-center shrink-0" data-id="element-182">
              <Check size={13} className="text-brand-primary" strokeWidth={3} data-id="element-183" />
            </span>
            {toast}
          </motion.div>}
      </AnimatePresence>
    </>;
}